'use client';

export default function cdnLoader({ src, width, quality }) {
    try {
        const u = new URL(src, 'https://dummy.base');
        const host = u.hostname;

        if (host === 'image.tmdb.org') {
            u.hostname = process.env.NEXT_PUBLIC_TMDB_IMAGE_CDN_DOMAIN;
        }

        if (host === 'cdn.' + process.env.CIN_DOMAIN || host === 'cdn.cineamo.com') {
            u.hostname = process.env.NEXT_PUBLIC_CINEAMO_IMAGE_CDN_DOMAIN;
        }

        if (!isNaN(width)) {
            u.searchParams.set('width', width.toString());
        }
        if (!isNaN(quality)) {
            u.searchParams.set('quality', quality.toString());
        }

        // Check if path has file extension, if not add optimizer=image
        const pathname = u.pathname;
        const hasExtension = /\.[a-zA-Z0-9]+$/.test(pathname);
        if (!hasExtension) {
            u.searchParams.set('optimizer', 'image');
        }

        // fallback: if the image is from another domain — return directly
        return u.toString();
    } catch {
        return src;
    }
}